/**
 * Configuration du Chatbot Botpress v3.5
 * 
 * Ce fichier permet de gérer quels tenants ont accès au chatbot
 * 
 * Nouvelle intégration avec :
 * - Détection automatique de langue (FR, EN, ES, DE, NL)
 * - API Botpress native (window.botpress)
 * - Scripts officiels Botpress v3.5
 */

export default {
  // Liste des tenants autorisés à utiliser le chatbot
  // Vous pouvez utiliser le slug, uuid, ou domain du tenant
  allowedTenants: [
    // Exemples - décommentez et remplacez par vos vrais identifiants
    'lephare',
    'cyclesn',
    'livraison',
    'slowvillage'
    // 'tenant-slug-2',
    // 'abc123-uuid-tenant-3',
    // 'mondomaine.com'
  ],
  
  // Si true, le chatbot sera disponible pour TOUS les tenants
  // Si false, seuls les tenants listés dans allowedTenants pourront l'utiliser
  enableForAllTenants: false,
  
  // Options d'affichage supplémentaires
  displayOptions: {
    // Activer les logs de debug
    debug: true
  }
}

